import React, { useState } from "react";
import Header from "../components/header";
import Breadcrumb from "../components/Breadcrumb";
import TableList from "../components/tableList";
import Footer from "../components/footer";
import CompletedOrderTable from "../components/completedOrderTable";
import DriverOrderTable from "../components/DriverOrderTable";

const OrderPickupDropPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const breadcrumbPaths = [
    { label: "Home", href: "/dashboard" },
    { label: "Abholung & Anlegen", href: "#" }, // Driver Order screen
  ];

  return (
    <div>
      <Header></Header>
      <div
        className="mx-auto container xl:w-full p-6 py-16 pt-28 2xl:pt-36
      before:content-[''] before:bottom-0 before:right-0 before:w-[200px] before:h-[220px] before:bg-cover before:bg-right-bottom before:bg-no-repeat before:fixed before:bg-[url('./assets/images/schreiber-right.svg')] before:hidden lg:before:block before:-z-10
      after:content-[''] after:bottom-0 after:left-0 after:w-[200px] after:h-[220px] after:bg-cover after:bg-left-bottom after:bg-no-repeat after:fixed after:bg-[url('./assets/images/schreiber-left.svg')] after:hidden lg:after:block after:-z-10
      "
      >
        <div className="flex justify-between">
          <Breadcrumb paths={breadcrumbPaths} />
          <input
            type="search"
            className="appearance-none border border-gray rounded-lg bg-white py-2 px-5 text-gray-600 placeholder:text-gray-400 hover:border-blue-600 focus:border-blue-600 focus:outline-none focus:shadow-outline"
            placeholder="Suche"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <DriverOrderTable searchTerm={searchTerm} />
      </div>
      <div className="xl:absolute bottom-0 w-full relative">
        {" "}
        <Footer />{" "}
      </div>
    </div>
  );
};

export default OrderPickupDropPage;
